import { BaseScopes } from "../models/scopes";
import { GSEndpoint } from "../models/endpoint";
import { User } from "../models/user";

export interface CampaignI {
    campaign: string;
    primaryProject?: string;
    backupProjects?: string[];
    difficulty: string;
}

export interface SubscriberI {
    email: string;
    name: string;
}

export class GetCampaigns extends GSEndpoint<{}, CampaignI[]> {
    constructor() {
        super("campaigns", "GET", [BaseScopes.MAINTAIN]);
    }
    override async request(user: User): Promise<CampaignI[]> {
        return await super.makeRequest({}, user);
    }
}

export class GetCampaignDetails extends GSEndpoint<{}, CampaignI> {
    constructor(campaignName: string) {
        super("campaigns/details/{campaignName}", "GET", [BaseScopes.MAINTAIN], undefined, [campaignName]);
    }
    override async request(user: User): Promise<CampaignI> {
        return await super.makeRequest({}, user);
    }
}

export class PostCampaign extends GSEndpoint<CampaignI, {}> {
    constructor() {
        super("campaigns", "POST", [BaseScopes.MAINTAIN]);
    }
    override async request(req: CampaignI, user: User): Promise<{}> {
        return await super.makeRequest(req, user);
    }
}

export class PutCampaign extends GSEndpoint<CampaignI, {}> {
    constructor() {
        super("campaigns", "PUT", [BaseScopes.MAINTAIN]);
    }
    override async request(req: CampaignI, user: User): Promise<{}> {
        return await super.makeRequest(req, user);
    }
}

export class DeleteCampaign extends GSEndpoint<{}, {}> {
    constructor(campaignName: string) {
        super("campaigns/{campaignName}", "DELETE", [BaseScopes.MAINTAIN], undefined, [campaignName]);
    }
    override async request(user: User): Promise<{}> {
        return await super.makeRequest({}, user);
    }
}

export class GetSubscribers extends GSEndpoint<{}, SubscriberI[]> {
    constructor(campaignName: string) {
        super("campaigns/{campaignName}/subscribers", "GET", [BaseScopes.MAINTAIN], undefined, [campaignName]);
    }
    override async request(user: User): Promise<SubscriberI[]> {
        return await super.makeRequest({}, user);
    }
}

export class PostSubscriber extends GSEndpoint<SubscriberI, {}> {
    constructor(campaignName: string) {
        super("campaigns/{campaignName}/subscribers", "POST", [BaseScopes.MAINTAIN], undefined, [campaignName]);
    }
    override async request(req: SubscriberI, user: User): Promise<{}> {
        return await super.makeRequest(req, user);
    }
}

export class DeleteSubscriber extends GSEndpoint<{}, {}> {
    constructor(campaignName: string, email: string) {
        super(
            "campaigns/{campaignName}/subscribers/{email}",
            "DELETE",
            [BaseScopes.MAINTAIN],
            undefined,
            [campaignName, encodeURIComponent(email)],
        );
    }
    override async request(user: User): Promise<{}> {
        return await super.makeRequest({}, user);
    }
}
